module.exports = __webpack_public_path__ + "static/reminder-email-dca208f8b89049721df64671f226245d.png";